<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("SmsPushSetting.RadioField.select_staff") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <!-- 组织 -->
        <v-col cols="12" sm="4">
          <v-row dense align="center" class="pa-1">
            <SearcherOrganization v-model="organizationSelected" />
          </v-row>
        </v-col>
        <!-- 角色 -->
        <v-col cols="12" sm="4">
          <v-row dense align="center" class="pa-1">
            <SearcherRole v-model="rolesSelected" />
          </v-row>
        </v-col>
        <!-- 员工名称 -->
        <v-col cols="12" sm="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="accountUsersKeyword"
              :label="$t('SmsPushSetting.TableTitle.staff_name')"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="accountUserItems"
        :loading="loading"
        multi-sort
        hide-default-footer
        class="elevation-0 px-6"
        v-resize="resizeHeader"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              accountUsers.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{
            $t("SmsPushSetting.RadioField.chooseCount", [changedDetails.length])
          }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="
            $emit(
              'confirm',
              changedDetails.filter((c) => c.new)
            );
            dialog = false;
          "
        >
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherOrganization from "@/components/plugins/SearcherOrganization";
import SearcherRole from "@/components/plugins/SearcherRole";
import AccountUsers from "@/api/account_users";

export default {
  name: "SmsPushSelectStaffsDialog",

  props: {
    value: Boolean,
    fetchOptions: Object,
    changed: Array,
    accountUserIds: Array,
    usersIdDisabled: Array,
  },

  components: {
    SearcherKeyword,
    SearcherRole,
    SearcherOrganization,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("SmsPushSetting.TableTitle.organization"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "organization.name",
        },
        {
          text: i18n.t("SmsPushSetting.TableTitle.role"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "role.role_name",
        },
        {
          text: i18n.t("SmsPushSetting.TableTitle.staff_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "name",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },
    accountUserItems() {
      //前端搜索
      return this.accountUsers.filter(
        (item) =>
          // 组织
          ((this.organizationSelected &&
            item.organization_code.indexOf(this.organizationSelected.code) >
              -1) ||
            !this.organizationSelected) &&
          // 角色
          ((this.rolesSelected && item.role_id == this.rolesSelected.id) ||
            !this.rolesSelected) &&
          // 员工名称
          ((this.accountUsersKeyword &&
            item.name.indexOf(this.accountUsersKeyword) > -1) ||
            !this.accountUsersKeyword)
      );
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    accountUsers: [],
    organizationSelected: null,
    rolesSelected: null,
    accountUsersKeyword: "",
    itemsPerPageOptions: 10,
    chooseAll: 0,
    changedDetails: [],
    fetchTimestamp: 0, //第一次获取商品列表的时间
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    //获取员工列表
    getAccountUsersFromAPI() {
      AccountUsers.fetch({ type: 2 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.accountUsers = response.data.account_users.map(
              (accountUser) => {
                //默认勾选
                let detail = this.changed.find((s) => accountUser.id == s.id);
                if (detail) {
                  accountUser = Object.assign({}, accountUser, {
                    choose: 1,
                  });
                } else {
                  accountUser = Object.assign({}, accountUser, {
                    choose: 0,
                  });
                }
                if (this.usersIdDisabled.indexOf(accountUser.id) > -1) {
                  accountUser = Object.assign({}, accountUser, {
                    disabled: true,
                  });
                }
                return accountUser;
              }
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          // 每次打开对话框重置查询条件和changedDetails
          this.accountUsersKeyword = "";
          if (this.changed) {
            this.changedDetails = [];
            this.changed.forEach((accountUser) => {
              let choosed = {
                new: this.changedDetails.length + 1,
                id: accountUser.id,
                organization_name: accountUser.organization_name,
                role_name: accountUser.role_name,
                name: accountUser.name,
                tel: accountUser.tel,
              };
              this.changedDetails.push(choosed);
            });
          }
          this.getAccountUsersFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.organizationSelected = null;
          this.rolesSelected = null;
          this.accountUsersKeyword = "";
          this.changedDetails = [];
          this.chooseAll = 0;
        }
      },
    },
    chooseAll: {
      handler() {
        this.accountUsers = this.accountUsers.map(
          function (detail) {
            var d = this.accountUserItems.find((d) => d.id == detail.id);
            if (d) detail.choose = this.chooseAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    accountUsers: {
      deep: true,
      handler() {
        this.accountUsers.forEach((accountUser) => {
          if (accountUser.choose == 1) {
            // 选中数据
            var detail = this.changedDetails.find(
              (s) => accountUser.id == s.id
            );
            if (!detail) {
              let choosed = {
                new: this.changedDetails.length + 1,
                id: accountUser.id,
                organization_name: accountUser.organization.name,
                role_name: accountUser.role.role_name,
                name: accountUser.name,
                tel: accountUser.tel,
              };
              this.changedDetails.push(choosed);
            }
          } else {
            // 取消选中
            if (
              this.changedDetails.findIndex(
                (d) => d.id == accountUser.id && d.new
              ) > -1
            ) {
              this.changedDetails.splice(
                this.changedDetails.findIndex(
                  (d) => d.id == accountUser.id && d.new && !d.disabled
                ),
                1
              );
            }
          }
        }); // 新改变的，添加到changedDetails数组中
      },
    },
  },
};
</script>